import { Icon, SideNavigation } from '@loadsmart/miranda-react'

import { NavLabel, NewTag } from 'core/ui/components/NavLabel'

type AssistantNavItemProps = {
  active: boolean
  onNavigate: () => void
}

export default function AssistantNavItem({ active, onNavigate }: AssistantNavItemProps) {
  return (
    <SideNavigation.Item
      href="/assistant"
      leading={<Icon name="chat" color="color-brand" />}
      active={active}
      onClick={event => {
        event.preventDefault()
        onNavigate()
      }}
    >
      <NavLabel>
        Assistant
        <NewTag>New</NewTag>
      </NavLabel>
    </SideNavigation.Item>
  )
}
